export default function SortableTh({
  label,
  field,
  filters,
  setFilters,
  ...props
}) {
  const active = filters?.sort_by === field;
  const order = filters?.sort_order;

  const handleSort = () => {
    setFilters({
      ...filters,
      sort_by: field,
      sort_order: active && order === "asc" ? "desc" : "asc",
      page: 1,
    });
  };

  return (
    <th
      {...props}
      onClick={handleSort}
      style={{ cursor: "pointer", userSelect: "none", whiteSpace: "nowrap" }}
    >
      {label}{" "}
      <i
        className={
          active
            ? order === "asc"
              ? "ri-arrow-up-s-line"
              : "ri-arrow-down-s-line"
            : "ri-expand-up-down-line text-muted"
        }
      ></i>
    </th>
  );
}
